import React from 'react';

const PresenterSection = () => {
  return (
    <section className="presenter-section" id="about">
      <div className="presenter-inner">
        <div className="presenter-sidebar">
          <div className="portrait-wrap">
            <div className="portrait-bg">
              <div className="portrait-init">SN</div>
            </div>
            <div className="portrait-bar"></div>
          </div>
          <p className="sb-name">Sunil Nikhar</p>
          <p className="sb-role">Founder &amp; M&A Advisor, ValueARC</p>
          <div className="chips">
            <span className="chip">IIT Mumbai</span>
            <span className="chip">IIM Ahmedabad</span>
            <span className="chip">EY Entrepreneur 2002</span>
            <span className="chip">TiE Pune Charter</span>
            <span className="chip">Rashtriya Abhimaan 2024</span>
          </div>
        </div>
        <div>
          <p className="section-eyebrow">Your Guide</p>
          <h2 className="section-title">Built by someone who learned it<br /><em>the expensive way.</em></h2>
          <blockquote className="bio-quote">"Despite two successful exits, I did not know what I did not know. I left value on the table. That gap is what eventually drove me to build ValueARC."</blockquote>
          <p className="bio-text">Sunil Nikhar has spent three decades building, scaling, and selling technology companies — and advising founders through their own exits. He has sat on every side of the M&A table: as a founder selling, as an investor buying, and as an advisor guiding dozens of founders through the most consequential financial event of their professional lives.</p>
          <p className="bio-text">His first company, Ascent Computing Group, made the Inc 500, Deloitte Fast 500, and Fast 50 before being acquired by chinadotcom (NASDAQ: CHINA). His second, Pyxis Systems — a Gartner Cool Vendor — was acquired by Polaris Financial Technology. Ernst &amp; Young named him Entrepreneur of the Year in 2002.</p>
          <p className="bio-text">Today, as Founder of ValueARC and India Head at Vertical Relevance (a premier AWS partner for Fortune 100 BFSI clients), he brings that hard-won experience to IT services founders preparing for their own exits.</p>
          <div className="bio-exits">
            <div className="exit-card"><p className="exit-co">Ascent Computing Group</p><p className="exit-det">Acquired by chinadotcom · NASDAQ: CHINA · Inc 500</p></div>
            <div className="exit-card"><p className="exit-co">Pyxis Systems</p><p className="exit-det">Acquired by Polaris Financial Technology · Gartner Cool Vendor</p></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresenterSection;
